import React from 'react'
import './section5.css'

import Lands from '../../assets/logo/lands.svg'
import Faber from '../../assets/logo/faber.svg'
import Alamo from '../../assets/logo/alamo.svg'
import Herder from '../../assets/logo/herder.svg'
import Si from '../../assets/logo/si.svg'
import Soufer from '../../assets/logo/soufer.svg'
import Banco from '../../assets/logo/banco.png'

const logos = [
    { src: Lands, alt: 'Landis+Gyr' },
    { src: Faber, alt: 'Faber-Castell' },
    { src: Alamo, alt: 'Alamo' },
    { src: Herder, alt: 'Herder' },
    { src: Si, alt: 'SI' },
    { src: Soufer, alt: 'Soufer' },
    { src: Banco, alt: 'Banco' },
]

export default function Section5() {
    return (
        <div id="section5" className="container-fluid">
            <div className="container">
                <div className="row mt-5">
                    <div className="col-12 text-center">
                        <label className="tituloSection d-flex justify-content-center">Clientes</label>
                        <label className="subTituloSection mt-2">Empresas que confiam na Oxfield</label>
                    </div>
                </div>
            </div>

            <div className="clients-marquee-wrapper" data-aos="fade-up">
                <div className="clients-marquee-track">
                    {[...logos, ...logos].map((logo, i) => (
                        <div key={i} className="clients-marquee-item">
                            <img src={logo.src} alt={logo.alt} />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}
